// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"227f6496","605":"a221a33d"}[chunkId] + ".chunk.js";
};